import angular from "angular";
import snakeToSpaceFilter from './snakeToSpace.filter';

let snakeToSpaceModule = angular.module('snakeToSpace.filter', [])
.filter('snakeToSpace', snakeToSpaceFilter)

.name;

export default snakeToSpaceModule;



// WEBPACK FOOTER //
// ./client/app/common/filters/snakeToSpaceService/snakeToSpace.js